<template>
  <div>
    <stats></stats>
    <div class="main">
      <LeftCol></LeftCol>
      <router-view></router-view>
      <calc v-on:send-bets="send_bets()" ref="num"></calc>
    </div>
  </div>
</template>

<script>
import stats from '@/components/Stats.vue'
import calc from '@/components/Calc.vue'
import LeftCol from '@/components/LeftCol.vue'

export default {
  name: 'main',
  components: {
    stats, calc, LeftCol
  },
  methods: {
    logout(){
      this.$store.dispatch('logout');
      this.$router.push({name: 'auth'});
    }
  },
};

</script>

<style>

</style>
